import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
interface AuthorNameWithImageProps {
  name?: FieldConfig;
  imageUrl?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
}
export default function AuthorNameWithImage(t0) {
  const $ = _c(22);
  const {
    name: t1,
    imageUrl: t2,
    slug,
    imageMetadata
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const name = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const imageUrl = t4;
  const nameValue = name?.value || "";
  let t5;
  if ($[4] !== imageUrl?.value) {
    t5 = getImageUrl(imageUrl?.value) || "";
    $[4] = imageUrl?.value;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const imageUrlValue = t5;
  let t6;
  if ($[6] !== imageMetadata || $[7] !== imageUrl?.customClass || $[8] !== imageUrl?.hidden || $[9] !== imageUrlValue || $[10] !== nameValue) {
    t6 = !imageUrl?.hidden && <div className={`w-20 h-20 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center ${imageUrl?.customClass || ""}`}>{imageUrlValue ? <Image src={imageUrlValue} alt={nameValue} width={80} height={80} className="w-full h-full object-cover" style={getFocusPointStyle(imageMetadata)} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /> : <svg className="w-12 h-12 text-gray-400" fill="currentColor" viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>}</div>;
    $[6] = imageMetadata;
    $[7] = imageUrl?.customClass;
    $[8] = imageUrl?.hidden;
    $[9] = imageUrlValue;
    $[10] = nameValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== name?.customClass || $[13] !== name?.hidden || $[14] !== nameValue) {
    t7 = !name?.hidden && <p className={`mt-3 text-14-tamil-700 text-1B1B1B text-center ${name?.customClass || ""}`}>{nameValue}</p>;
    $[12] = name?.customClass;
    $[13] = name?.hidden;
    $[14] = nameValue;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="flex flex-col items-center p-4">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const content = t8;
  if (slug) {
    const t9 = `${slug}`;
    let t10;
    if ($[19] !== content || $[20] !== t9) {
      t10 = <Link href={t9} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[19] = content;
      $[20] = t9;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    return t10;
  }
  return content;
}